import { EntityMigration } from "../../entity/EntityMigration";

export class DtoMigrationsDeleteRes extends EntityMigration {
  public message: string | null = null;
}
